<template>
<div class="panel bgPanel mt1x cb mr1x ml1x">
	<div class="title title-bg">
		<span :title="getLanguageStr('word1748','电网实时')">{{getLanguageStr("word1748","电网实时")}}</span>
		<!-- <div class="tool">
				<button class="more fa fa-angle-right tra-fast"></button>
		</div> -->
	</div>
		<div>
			<div class="clearfix fL_E w50pct_E pl2x_E pr2x_E">
				<div class="mt1x">
					<div class="bdSub-bottom pb2x dpIB_E vaT_E ">
						<div class="taC mr1x">
							<div class="icoSys h3x w3x" :class="{bgPrimary:stationInfo.wirePower,bgLight:!stationInfo.wirePower}">
								<svg :class="{fWhite:stationInfo.wirePower,fSub:!stationInfo.wirePower}">
									<use xlink:href="#ico-eTower"></use>
								</svg>
							</div>
							<div class="mt05x">
								<span v-if="JSON.stringify(stationInfo) =='{}' || !stationInfo.wireStatus">--</span>
								<div v-else>
									<span :title="getTypeText(stationInfo.wireStatus,'wireStatus')">{{getTypeText(stationInfo.wireStatus,'wireStatus')}}</span>
									<div>
										<Icon v-if="stationInfo.wireStatus=='GRID_CONNECTED'" name="dirArrow-l" class="w2x h1x fMain" />
										<Icon v-if="stationInfo.wireStatus=='PURCHASE'" name="dirArrow-r" class="w2x h1x fMain" />
									</div>
								</div>
							</div>
						</div>
						<ul class="fL_E clearfix pl2x mr3x_E">
							<li>
								<div class="mb1x" :title="$t('word190',['电网功率'])">{{$t("word190",["电网功率"])}}</div>
								<div class="cMain">
									<span :title="convertData(Math.abs(stationInfo.wirePower),2,'','W')[0]">
										<span v-if="stationInfo.wirePower==null">--</span>
										<span v-else>
											<span class="fs14x">{{convertData(Math.abs(stationInfo.wirePower),2,"","W")[1]}}</span>
											{{convertData(Math.abs(stationInfo.wirePower),2,"","W")[2]}}
										</span>
									</span>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="clearfix fL_E w50pct_E pl2x_E pr2x_E">
				<div>
					<div class="pt2x pb2x tableSys vaM_E">
						<div class="w40pct bdSub-right">
							<div class="dpIB">
								<div class="mb2x" :title="$t('word501',['当日并网量'])">{{$t("word501",["当日并网量"])}}</div>
								<div class="cMain" :title="convertData(stationInfo.gridValue,2,'k','Wh')[0]">
									<span class="fs16x">{{convertData(stationInfo.gridValue,2,"k","Wh")[1]}}</span>
										{{convertData(stationInfo.gridValue,2,"k","Wh")[2]}}
								</div>
							</div>
						</div>
						<div class="pl3x lh13">
							<div class="mb1x"><span class="mr2x" :title="$t('word503',['当月并网量'])">{{$t("word503",["当月并网量"])}}</span><span :title="convertData(stationInfo.gridMonth,2,'k','Wh')[0]">{{convertData(stationInfo.gridMonth ,2,"k","Wh")[0]}}</span></div>
							<div class="mb1x"><span class="mr2x" :title="$t('word505',['当年并网量'])">{{$t("word505",["当年并网量"])}}</span><span :title="convertData(stationInfo.gridYear,2,'k','Wh')[0]">{{convertData(stationInfo.gridYear ,2,"k","Wh")[0]}}</span></div>
							<div><span class="mr2x" :title="$t('word499',['累计并网量'])">{{$t("word499",["累计并网量"])}}</span><span :title="convertData(stationInfo.gridUploadTotal,2,'k','Wh')[0]">{{convertData(stationInfo.gridUploadTotal ,2,"k","Wh")[0]}}</span></div>
						</div>
					</div>
				</div>
				<div>
					<div class="pt2x pb2x tableSys vaM_E">
						<div class="w40pct bdSub-right">
							<div class="dpIB">
								<div class="mb2x" :title="$t('word502',['当日购电量'])">{{$t("word502",["当日购电量"])}}</div>
								<div class="cMain" :title="convertData(stationInfo.buyValue ,2,'k','Wh')[0]">
									<span class="fs16x">{{convertData(stationInfo.buyValue ,2,"k","Wh")[1]}}</span>
									{{convertData(stationInfo.buyValue ,2,"k","Wh")[2]}}
								</div>
							</div>
						</div>
						<div class="pl3x lh13">
							<div class="mb1x"><span class="mr2x" :title="$t('word504',['当月购电量'])">{{$t("word504",["当月购电量"])}}</span><span :title="convertData(stationInfo.buyMonth,2,'k','Wh')[0]">{{convertData(stationInfo.buyMonth ,2,"k","Wh")[0]}}</span></div>
							<div class="mb1x"><span class="mr2x" :title="$t('word506',['当年购电量'])">{{$t("word506",["当年购电量"])}}</span><span :title="convertData(stationInfo.buyYear,2,'k','Wh')[0]">{{convertData(stationInfo.buyYear ,2,"k","Wh")[0]}}</span></div>
							<div><span class="mr2x" :title="$t('word500',['累计购电量'])">{{$t("word500",["累计购电量"])}}</span><span :title="convertData(stationInfo.buyUploadTotal,2,'k','Wh')[0]">{{convertData(stationInfo.buyUploadTotal ,2,"k","Wh")[0]}}</span></div>
						</div>
					</div>
				</div>
			</div>

		</div>
	<div class="pl2x pr2x">
	</div>
</div>
</template>
<script>
import Loading from '@/components/common/ui/Loading'
import * as equipmentApi from '@/api/maintain/plant/list'
import * as lib from '@/util/lib.js'
import {getLanguageStr} from '@/util/language.js'
export default {
	name: 'GridPower',
	components: {Loading},
	data () {
		return {
			isLoading: false,
			stationInfo: {}
		}
	},
	methods: {
		getLanguageStr,
		getTypeText: lib.getTypeText,
		floatFix: lib.floatFix,
		convertData: lib.convertData,
		show (data) {
			if (data.stationInfo) {
				this.stationInfo = data.stationInfo
				setTimeout(() => {
					this.isLoading = false
				}, 500)
			} else {
				this._getList(data.stationId)
			}
		},
		_getList (id) {
			this.isLoading = true
			equipmentApi.StationInfo(id).then(res => {
				this.isLoading = false
				this.stationInfo = res
			}, error => {
				this.isLoading = false
				!_.isEmpty(error) && this.$notify(error)
			})
		}

	}
}
</script>
<style lang="scss" scoped>
.panel .title{ margin-bottom: 0 }
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/detail/GridPower.vue